import React, { useState } from 'react';
import { Button } from 'antd';

import win7Icon from '../../assets/win7.png';
import win10Icon from '../../assets/win10.png';
import win11Icon from '../../assets/win11.png';
import step4 from '../../assets/PythonInstallGuide/Step4.png';
import step4Win11 from '../../assets/PythonInstallGuide/Step4_win11.png';
import step5 from '../../assets/PythonInstallGuide/Step5.png';
import step52 from '../../assets/PythonInstallGuide/Step5.2.png';
import step53 from '../../assets/PythonInstallGuide/Step5.3.png';
import step54 from '../../assets/PythonInstallGuide/Step5.4.png';
import step5Win10 from '../../assets/PythonInstallGuide/Step5_win10.png';
import step5Win11 from '../../assets/PythonInstallGuide/Step5_win11.png';
import step52Win11 from '../../assets/PythonInstallGuide/Step5.2_win11.png';
import step53Win11 from '../../assets/PythonInstallGuide/Step5.3_win11.png';
import step6Win10 from '../../assets/PythonInstallGuide/Step6_win10.png';
import step6Win11 from '../../assets/PythonInstallGuide/Step6_win11.png';
import step7 from '../../assets/PythonInstallGuide/Step7.png';
import step7Win10 from '../../assets/PythonInstallGuide/Step7_win10.png';
import step7Win11 from '../../assets/PythonInstallGuide/Step7_win11.png';

import styles from './index.less';

type OsType = 'win7' | 'win10' | 'win11';
const css = (name: string): string => styles[name] ?? '';
const osIcons: Readonly<Record<OsType, string>> = {
  win7: win7Icon,
  win10: win10Icon,
  win11: win11Icon,
};
const guideAssets: Readonly<Record<string, string>> = {
  Step4: step4,
  Step4_win11: step4Win11,
  Step5: step5,
  'Step5.2': step52,
  'Step5.3': step53,
  'Step5.4': step54,
  Step5_win10: step5Win10,
  Step5_win11: step5Win11,
  'Step5.2_win11': step52Win11,
  'Step5.3_win11': step53Win11,
  Step6_win10: step6Win10,
  Step6_win11: step6Win11,
  Step7: step7,
  Step7_win10: step7Win10,
  Step7_win11: step7Win11,
};
const guideAsset = (name: string): string => guideAssets[name.replace(/\.png$/u, '')] ?? '';

export default function PythonInstallGuide(): React.ReactElement {
  const [osType, setOsType] = useState<OsType | null>(null);
  const [activeStep, setActiveStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);
  const handleNext = (): void => {
    if (activeStep >= 8) return;
    setActiveStep(activeStep + 1);
    if (!completedSteps.includes(activeStep)) setCompletedSteps([...completedSteps, activeStep]);
  };
  const handlePrevious = (): void => {
    if (activeStep > 1) setActiveStep(activeStep - 1);
  };
  const selectOs = (os: OsType): void => {
    setOsType(os);
    setActiveStep(os === 'win10' || os === 'win11' ? 3 : 1);
  };
  const shouldShowStep = (step: number): boolean => osType === 'win7' || step >= 3;
  const stepNumber = (step: number): number =>
    osType === 'win10' || osType === 'win11' ? step - 2 : step;
  const stepClass = (step: number): string =>
    `${css('step')} ${activeStep === step ? css('active') : ''}`;

  if (!osType) {
    return (
      <div className={css('osSelection')}>
        <h1>请选择您的操作系统</h1>
        <div className={css('osOptions')}>
          {(['win7', 'win10', 'win11'] as const).map((os) => (
            <div key={os} className={css('osOption')} onClick={() => selectOs(os)}>
              <div className={css('osIcon')}>
                <img src={osIcons[os]} alt="" />
              </div>
              <h2>Windows {os.slice(3)}</h2>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={css('pythonInstallGuide')}>
      <h1>
        Python 3.8.10 安装指南 -
        {osType === 'win7' ? 'Windows 7' : osType === 'win10' ? 'Windows 10' : 'Windows 11'}
      </h1>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
        <Button
          onClick={() => {
            setOsType(null);
            setActiveStep(1);
          }}
        >
          重新选择系统
        </Button>
      </div>
      <div className={css('stepsContainer')}>
        {shouldShowStep(1) ? (
          <div className={stepClass(1)}>
            <div className={css('stepHeader')} onClick={() => setActiveStep(1)}>
              <h2>步骤1: 下载 Windows6.1-KB2533623-x86 补丁</h2>
            </div>
            {activeStep === 1 ? (
              <div className={css('stepContent')}>
                <p>首先需要下载并安装 Windows 补丁 KB2533623</p>
                <a
                  href="/Windows6.1-KB2533623-x86.msu"
                  download="Windows6.1-KB2533623-x86.msu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css('downloadBtn')}
                >
                  下载补丁
                </a>
                <div className={css('stepActions')}>
                  <div />
                  <Button type="primary" onClick={handleNext}>
                    下一步
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        {shouldShowStep(2) ? (
          <div className={stepClass(2)}>
            <div className={css('stepHeader')} onClick={() => setActiveStep(2)}>
              <h2>步骤2: 重启电脑</h2>
            </div>
            {activeStep === 2 ? (
              <div className={css('stepContent')}>
                <p>安装补丁后，请重启您的计算机</p>
                <div className={css('stepActions')}>
                  <Button type="primary" onClick={handlePrevious}>
                    上一步
                  </Button>
                  <Button type="primary" onClick={handleNext}>
                    下一步
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        <div className={stepClass(3)}>
          <div className={css('stepHeader')} onClick={() => setActiveStep(3)}>
            <h2>步骤{stepNumber(3)}: 下载 Python 3.8.10</h2>
          </div>
          {activeStep === 3 ? (
            <div className={css('stepContent')}>
              <p>从阿里云镜像下载 Python 3.8.10 安装包</p>
              <a
                href="https://mirrors.aliyun.com/python-release/windows/python-3.8.10.exe"
                download="python-3.8.10.exe"
                target="_blank"
                rel="noopener noreferrer"
                className={css('downloadBtn')}
              >
                下载 Python 3.8.10
              </a>
              <div className={css('stepActions')}>
                {osType === 'win7' ? (
                  <Button type="primary" onClick={handlePrevious}>
                    上一步
                  </Button>
                ) : (
                  <div />
                )}
                <Button type="primary" onClick={handleNext}>
                  下一步
                </Button>
              </div>
            </div>
          ) : null}
        </div>
        <div className={stepClass(4)}>
          <div className={css('stepHeader')} onClick={() => setActiveStep(4)}>
            <h2>步骤{stepNumber(4)}: 安装 Python</h2>
          </div>
          {activeStep === 4 ? (
            <div className={css('stepContent')}>
              <p>运行下载的安装程序，并确保勾选 &quot;Add Python 3.8 to PATH&quot; 选项</p>
              <div className={css('imagePlaceholder')}>
                <img
                  src={guideAsset(
                    osType === 'win10' || osType === 'win11' ? 'Step4_win11' : 'Step4',
                  )}
                  alt=""
                />
              </div>
              <div className={css('stepActions')}>
                <Button type="primary" onClick={handlePrevious}>
                  上一步
                </Button>
                <Button type="primary" onClick={handleNext}>
                  下一步
                </Button>
              </div>
            </div>
          ) : null}
        </div>
        <div className={stepClass(5)}>
          <div className={css('stepHeader')} onClick={() => setActiveStep(5)}>
            <h2>步骤{stepNumber(5)}: 更改默认应用</h2>
          </div>
          {activeStep === 5 ? (
            <div className={css('stepContent')}>
              {osType === 'win7' ? (
                <div className="os-specific">
                  <h3>Windows 7:</h3>
                  <ol>
                    <li>按Win键选择&quot;默认程序&quot;</li>
                    <li>找到并选中&quot;.py&quot;文件</li>
                    <li>右上角点击&quot;更改程序&quot;</li>
                  </ol>
                  <div className={css('imagePlaceholder')}>
                    {['Step5.png', 'Step5.2.png', 'Step5.3.png', 'Step5.4.png'].map((asset) => (
                      <img key={asset} src={guideAsset(asset)} alt="" />
                    ))}
                  </div>
                </div>
              ) : (
                <div className="os-specific">
                  <h3>{osType === 'win10' ? 'Windows 10' : 'Windows 11'}:</h3>
                  {osType === 'win10' ? (
                    <ol>
                      <li>
                        前往目录:<code>C:\Users\用户\AppData\Local\Programs\Python</code>
                      </li>
                      <li>其中&quot;用户&quot;为本机名称</li>
                      <li>选择需要的 Python 版本文件夹，进入&quot;Lib\idlelib&quot;目录</li>
                      <li>找到任意一个python文件，右键点击&quot;打开方式&quot;</li>
                    </ol>
                  ) : (
                    <ol>
                      <li>按Win键搜索&quot;默认应用&quot;</li>
                      <li>搜索&quot;.py&quot;</li>
                      <li>点击后选择&quot;在电脑上选择应用&quot;</li>
                    </ol>
                  )}
                  <div className={css('imagePlaceholder')}>
                    {(osType === 'win10'
                      ? ['Step5_win10.png']
                      : ['Step5_win11.png', 'Step5.2_win11.png', 'Step5.3_win11.png']
                    ).map((asset) => (
                      <img key={asset} src={guideAsset(asset)} alt="" />
                    ))}
                  </div>
                </div>
              )}
              <div className={css('stepActions')}>
                <Button type="primary" onClick={handlePrevious}>
                  上一步
                </Button>
                <Button type="primary" onClick={handleNext}>
                  下一步
                </Button>
              </div>
            </div>
          ) : null}
        </div>
        <div className={stepClass(6)}>
          <div className={css('stepHeader')} onClick={() => setActiveStep(6)}>
            <h2>步骤{stepNumber(6)}: 选择 IDLE 文件路径</h2>
          </div>
          {activeStep === 6 ? (
            <div className={css('stepContent')}>
              <ol>
                <li>
                  前往目录:<code>C:\Users\用户\AppData\Local\Programs\Python</code>
                </li>
                <li>其中&quot;用户&quot;为本机名称</li>
                <li>选择需要的 Python 版本文件夹，进入&quot;Lib\idlelib&quot;目录</li>
              </ol>
              <div className={css('imagePlaceholder')}>
                <img src={guideAsset(osType === 'win10' ? 'Step6_win10' : 'Step6_win11')} alt="" />
              </div>
              <div className={css('stepActions')}>
                <Button type="primary" onClick={handlePrevious}>
                  上一步
                </Button>
                <Button type="primary" onClick={handleNext}>
                  下一步
                </Button>
              </div>
            </div>
          ) : null}
        </div>
        <div className={stepClass(7)}>
          <div className={css('stepHeader')} onClick={() => setActiveStep(7)}>
            <h2>步骤{stepNumber(7)}: 设置默认打开方式</h2>
          </div>
          {activeStep === 7 ? (
            <div className={css('stepContent')}>
              <ol>
                <li>在idlelib目录中找到idle.bat文件</li>
                <li>双击idle.bat</li>
                <li>在打开方式对话框中选择&quot;设置默认值&quot;</li>
              </ol>
              <div className={css('imagePlaceholder')}>
                <img src={guideAsset(`Step7${osType === 'win7' ? '' : `_${osType}`}`)} alt="" />
              </div>
              <div className={css('stepActions')}>
                <Button type="primary" onClick={handlePrevious}>
                  上一步
                </Button>
                <Button type="primary" onClick={handleNext}>
                  下一步
                </Button>
              </div>
            </div>
          ) : null}
        </div>
        <div className={stepClass(8)}>
          <div className={css('stepHeader')} onClick={() => setActiveStep(8)}>
            <h2>步骤{stepNumber(8)}: 重启教师端服务</h2>
          </div>
          {activeStep === 8 ? (
            <div className={css('stepContent')}>
              <p>完成所有安装步骤后，请重启教师端服务</p>
              <div className={css('stepActions')}>
                <Button type="primary" onClick={handlePrevious}>
                  上一步
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setOsType(null);
                    setActiveStep(1);
                    window.alert('安装指南完成！');
                  }}
                >
                  完成
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
